import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import type { Product } from '../types'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getCurrencySymbol(currency: string): string {
  return (
    new Intl.NumberFormat('en-PH', { style: 'currency', currency })
      .formatToParts(0)
      .find((p) => p.type === 'currency')?.value ?? currency
  )
}

export function formatCurrency(value: number, currency = 'PHP'): string {
  return new Intl.NumberFormat('en-PH', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

export function getBundleEffectiveQty(bundle: Product, allProducts: Product[]): number {
  if (!bundle.is_bundle || bundle.bundle_items.length === 0) return 0
  return Math.min(...bundle.bundle_items.map(bi => {
    const comp = allProducts.find(p => p.id === bi.component_product_id)
    return comp ? Math.floor(comp.current_stock / bi.qty) : 0
  }))
}
